export default __webpack_public_path__ + "static/char-s-39-ja-d135413c6c480bc4ee1256d9adcb0793.png";